const initialState = {
  logged: false,
  challenge: "",
  username: "",
  splashing: true,
  scheduledJobs: 0,
  tcount: 0,
  JRR: "",
}
const apiReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case "CHANGE_LOGGED":
      return Object.assign({}, state, {
        logged: action.value,
      })
    case "CHANGE_SPLASHING":
      return Object.assign({}, state, {
        splashing: action.value,
      })
    case "INCREMENT_TCOUNT":
      return Object.assign({}, state, {
        tcount: state.tcount + 1,
      })
    case "ADD_JRR":
      return Object.assign({}, state, {
        JRR: action.value,
      })
    case "REMOVE_JRR":
      return Object.assign({}, state, {
        JRR: "",
      })
    case "CHANGE_SCHEDULED_JOBS":
      return Object.assign({}, state, {
        scheduledJobs: action.value,
      })
    case "DROP_API":
      return { ...initialState }
    default:
      return state
  }
}

export default apiReducer
